export const GET_REQUIREMENT = "GET_REQUIREMENT";
export const GET_REQUIREMENT_ERROR = "GET_REQUIREMENT_ERROR";
export const GET_REQUIREMENT_SUCCESS = "GET_REQUIREMENT_SUCCESS";
